import React from 'react';
import ReactDOM from 'react-dom/client';

import AppWithLanding from './AppWithLanding';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AppWithLanding />
  </React.StrictMode>
);
